import { BREAKPOINTS as m } from "../constants/index.js";
import { useMediaQuery as i } from "./useMediaQuery.js";
const p = {
  up: {
    sm: `(min-width: ${m.sm}px)`,
    md: `(min-width: ${m.md}px)`,
    lg: `(min-width: ${m.lg}px)`
  },
  down: {
    xs: `(max-width: ${m.sm - 1}px)`,
    sm: `(max-width: ${m.md - 1}px)`,
    md: `(max-width: ${m.lg - 1}px)`
  },
  only: {
    xs: `(max-width: ${m.sm - 1}px)`,
    sm: `(min-width: ${m.sm}px) and (max-width: ${m.md - 1}px)`,
    md: `(min-width: ${m.md}px) and (max-width: ${m.lg - 1}px)`,
    lg: `(min-width: ${m.lg}px)`
  }
}, t = i;
export {
  p as mediaQueries,
  t as useResponsiveViewport
};
